<template>
  <div class="ul-page" v-loading="loading" element-loading-background="#fff">
    <div class="ul-page__inner" v-show="!loading">
      <div class="ul-page__header">
        <div class="ul-page__header-content" :class="{'full-width': fullHeader, 'higher': higher}">
          <div class="ul-page_header-left">
            <slot name="left" class="left">
              <a v-if="domain == 'hnylkc'" :href="hnkcPath" class="hnkc"><img class="logo" src="@/assets/images/hnkcLogo.png"></a>
              <a class="home-entry" v-else :href="homePath"><img class="logo" :src="logo"></a>
            </slot>
          </div>
          <div class="ul-page__header-right">
            <slot name="right" class="right"><ul-button hollow size="small" @click="close">关闭</ul-button></slot>
          </div>
        </div>
      </div>
      <div class="ul-page__body">
        <ul-scrollbar
          tag="div"
          ref="scrollbar"
          class="scrollbar-body"
          wrapStyle="max-height:100%;overflow-x:auto;"
          >
          <div class="ul-page__body-content" :class="{'full-width': fullBody, 'fixed-width': contentWidthFixed}">
            <slot></slot>
          </div>
        </ul-scrollbar>
      </div>
      <div class="ul-page_footer">
        <slot name="footer">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { hostDomain, UMOOC_SERVER_HOST} from '@/config'
import { mapGetters } from 'vuex'
import { buildUrlProtocol, buildResourcePath } from '@/utils'
import { getOrgMenuInfo } from '@/api/courseApi'
export default {
  name: 'UlPage',
  props: {
    title: String,
    loading: Boolean,
    fullBody: Boolean, // page-body水平方向是否占满页面
    fullHeader: {
      type: Boolean,
      default: true
    }, // page-header水平方向是否占满页面
    higher: Boolean, //page-header true高度60 false 50
    contentWidthFixed: {  //body-content区域宽度是否固定（不随着页面宽度变化而分档变化，默认跟随变化）
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hnkcPath: `http://hnylkc${hostDomain}`,
      domain: '',
      // homePath: `https://www${UMOOC_COOKIE_DOMAIN}`,
    }
  },
  computed: {
    ...mapGetters({user: 'user/user', org: 'org/org'}),
    homePath () {
      // if (this.user.orgHome) {
      //   return buildUrlProtocol(this.user.orgHome)
      // }
      if (this.org.isMainSite) {
        return `${UMOOC_SERVER_HOST}`
      }
      if (this.org.prefix == 'hnyl') {
        return `https://hnylkc${hostDomain}`
      }
      return `https://${this.org.prefix + hostDomain}`
    },
    logo () {
      // if (this.user.orgLogo) {
      //   return buildResourcePath(this.user.orgLogo)
      // }
      if (!this.org.isMainSite) {
        return this.org.logo
      }
      return require('@/assets/images/logo.png')
    }
  },
  created () {
    window.test = this
    this.domain = this.$route.query.domain
  },
  mounted(){
  if (this.$route.query.isIframe) {
      document.querySelector(".ul-page__header").remove()
      document.querySelector(".content-footer").remove()}
 },
  methods: {
    close () {
      window.close()
    },
  }
}
</script>

<style lang="scss" scoped>
.ul-page{
  height: 100%;  
}
.ul-page__inner{
  height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  .ul-page__header-content,.ul-page__body-content{
    width: $pageWidth;
    margin: 0px auto;
    @media(max-width: 1200px) {
      width: $pageWidthSmall;
    }
  }
}
.ul-page__header{
  
  // padding: 10px 20px;
  z-index: 1;
  background-color: $--color-white;
  box-sizing: border-box;
  box-shadow: $--box-shadow-base;
}
.ul-page__header-content{
  display: flex;
  height: 50px;
  justify-content: space-between;
  align-items: center;
  &.higher{
    height: 60px;
  }
  &.full-width{
    padding: 0 20px;
    width: auto;
  }
  .ul-page_header-left{
    display: flex;
    .hnkc {
      font-size: 22px;
      color: #444;
      font-weight: bold;
      display: flex;
      align-items: center;
    }
    .home-entry{
      font-size: 0;
    }
  }
  .logo{
    height: 40px;
    width: auto;
  }
}

.ul-page__body{
  flex: 1;
  width: 100%;
  height: 0;
  // overflow: hidden;
}
.ul-scrollbar{
  height: 100%;
}

.ul-page__body-content{
  box-sizing: border-box;
  background-color: $--color-white;
  &.full-width{
    width: auto;
    @media(max-width: 1200px) {
      width: auto;
    }
  }
  &.fixed-width{
    @media(max-width: 1200px) {
      width: $pageWidth;
    }
  }
}


@media (max-width: 768px) {
  .ul-page__header{
    display: none;
  }
  .ul-page__body{
    background-color: $--color-white;
  }
  .ul-page_footer{
    background-color: $--color-white;
  }
}
</style>